import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';
import { FeatureFlagService } from '@toro/common/shared/services/feature-flag/feature-flag.service';
import { AnalysisPreviewDialogComponent } from './analysis-preview-dialog.component';

@NgModule({
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    imports: [CommonModule, MatSlideToggleModule, SvgIconModule],
    declarations: [ AnalysisPreviewDialogComponent ],
    entryComponents: [ AnalysisPreviewDialogComponent ],
    providers: [ FeatureFlagService ],
})

export class AnalysisPreviewDialogModule {}
